import { create } from 'zustand';
import { combine } from 'zustand/middleware';
import { MeetingSettings } from '@/types/meeting';

interface MeetingSettingsStates {
  settings: MeetingSettings;
}

interface MeetingSettingsActions {
  setSettings: (newSettings: MeetingSettings) => void;
}

export const useMeetingSettingsStore = create(
  combine<MeetingSettingsStates, MeetingSettingsActions>(
    {
      settings: {
        autoExitWithTeacherFromRoom: false,
        canStudentsSelfTransitionToRooms: false,
        canStudentsHandUpInRooms: false
      }
    },
    (set) => ({
      setSettings: (newSettings) => set({ settings: newSettings })
    })
  )
);
